import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import style from './style.css';
import ColorPicker from '../async/colorpicker';
import { onChange } from '../../../controller/theme_checkout';
import common from '../../../common/common';

class ColorBar extends Component {
  constructor(props) {
    super(props);
    this.toggleColorPicker = this.toggleColorPicker.bind(this, props.colorInfo.NAME);
    this.hideColorPicker = this.hideColorPicker.bind(this);
    this.onKeyupHandle = this.onKeyupHandle.bind(this, props.colorInfo.NAME);
    this.state = { isColorPickerOpen: false, isColorBoxClicked: false };
  }

  componentDidMount() {
    window.addEventListener('click', this.hideColorPicker);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.hideColorPicker);
  }

  hideColorPicker() {
    this.setState({ isColorPickerOpen: false, isColorBoxClicked: false });
  }

  toggleColorPicker(label, e) {
    if (this.state.isColorBoxClicked === false) {
      document.getElementById('app').click();
    }
    e.preventDefault();
    e.stopPropagation();
    if (!this.state.isColorPickerOpen) {
      common.log('onColorPickerClick', label);
    }
    this.setState(state => ({
      isColorPickerOpen: !state.isColorPickerOpen,
      isColorBoxClicked: true
    }));
  }

  onKeyupHandle(label, e) {
    if (e) {
      const colorCode = `#${e.target.value.replace(/[^0-9a-fA-F]/g, '')}`;
      common.log('onKeyInput', label, { colorCode });
      if (this.props && this.props.onColorChange && this.props.colorInfo) {
        this.props.onColorChange(this.props.colorInfo.KEY, { hex: colorCode });
      }
    }
  }

  render({ colorInfo }, { isColorPickerOpen }) {
    const codeWithoutHash = colorInfo.CODE.substring(1);
    return (
      <div className={`${style['theme-card']} ib`}>
        <span className={`${style['comp-name']}`}>{colorInfo.NAME}</span>
        <div className={`${style['theme-colorbox']} right pos-r`}>
          <input type="text" value={codeWithoutHash} maxLength="8" onKeyUp={this.onKeyupHandle} />
          <span className={`${style['hash-code']}`}>#</span>
          <div
            className={`${style['color-code']} pos-a`}
            style={`background:${colorInfo.CODE}`}
            onClick={this.toggleColorPicker}
          />
          {isColorPickerOpen && <ColorPicker colorInfo={colorInfo} />}
        </div>
      </div>
    );
  }
}
export default connect(
  null,
  onChange
)(ColorBar);



// WEBPACK FOOTER //
// ./checkout/components/colorbar/index.js